import toast from 'react-hot-toast';
import { EXTRA_BOTTOM } from '@/features/toast-container/constant';
export const showVariantErrorToast = (errorMessage: string) => {
  toast.error(errorMessage, {
    duration: 3000,
    id: 'no-atp-selected-toast',
    style: {
      maxWidth: 'max-content',
      bottom: EXTRA_BOTTOM
    }
  });
};